import { motion } from "framer-motion";
import { FIRM } from "../../data/firm";

const MSG = encodeURIComponent("Hello Jay Kular & Associates, I would like to enquire about SEBI compliance services.");

export const WhatsAppButton = () => (
  <motion.a
    data-testid="whatsapp-float-button"
    href={`https://wa.me/${FIRM.whatsapp}?text=${MSG}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-50 flex items-center gap-3"
  >
    <span className="hidden sm:block rounded-full bg-ink text-paper text-sm font-medium px-4 py-2 shadow-xl opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300">
      Chat on WhatsApp
    </span>
    <span className="relative grid place-items-center w-14 h-14 rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.45)]">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <svg viewBox="0 0 32 32" className="relative w-7 h-7 fill-white" aria-hidden="true">
        <path d="M16.04 3C9.4 3 4 8.38 4 15c0 2.12.56 4.19 1.61 6.01L4 29l8.2-1.58A12 12 0 0 0 16.04 27C22.66 27 28 21.62 28 15S22.66 3 16.04 3Zm0 21.8c-1.8 0-3.56-.48-5.1-1.4l-.37-.22-4.86.94.97-4.7-.24-.39A9.73 9.73 0 0 1 6.27 15c0-5.38 4.39-9.76 9.77-9.76 5.37 0 9.73 4.38 9.73 9.76s-4.36 9.8-9.73 9.8Zm5.35-7.3c-.29-.15-1.73-.85-2-.95-.27-.1-.46-.15-.66.15-.2.29-.76.95-.93 1.14-.17.2-.34.22-.63.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.73-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.58-.9-2.17-.24-.57-.48-.49-.66-.5h-.56c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.2 2.06 3.15 5 4.42.7.3 1.25.48 1.67.62.7.22 1.34.19 1.85.12.56-.08 1.73-.71 1.98-1.4.24-.68.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34Z" />
      </svg>
    </span>
  </motion.a>
);
